import React, { useState, useEffect } from 'react';
import TiltedCard from './components/TiltedCard';
import './CoordinatorsPage.css';

const CoordinatorsPage = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setLoading(false);
  }, []);

  // Coordinators data - 22 members organized by hierarchy
  const coordinators = [
    // President (1)
    { id: 1, name: 'Dhivakar B S', title: 'President', place: 'Chennai', image: '/coord/new_dhivakar.jpeg', linkedin: 'https://www.linkedin.com/in/dhivakar-b-s-247a1a283?utm_source=share_via&utm_content=profile&utm_medium=member_android' },
    
    // Vice President (1)
    { id: 2, name: 'Kanishka N', title: 'Vice President', place: 'Coimbatore', image: '/coord/VICE_PRESIDENT- KANISHKA_N.jpeg', linkedin: 'https://www.linkedin.com/in/kanishka-natarajan?utm_source=share_via&utm_content=profile&utm_medium=member_android' },
    
    // Secretary (1) - Adding missing secretary
    { id: 3, name: 'Shyam Rajan S', title: 'Secretary', place: 'Bangalore', image: '/coord/SECRETARY-SHYAM_RAJAN_S.jpeg', linkedin: 'https://www.linkedin.com/in/shyamrajans?utm_source=share_via&utm_content=profile&utm_medium=member_android' },
    
    // Joint Secretary (1)
    { id: 4, name: 'Maushmi B', title: 'Joint Secretary', place: 'Delhi', image: '/coord/JOINT_SECRETARY-MAUSHMI_B.jpeg', linkedin: 'https://www.linkedin.com/in/maushmi-b-708832304?utm_source=share_via&utm_content=profile&utm_medium=member_android' },
    
    // Technical Heads (4) - Alphabetical order
    { id: 5, name: 'Balamurali S R', title: 'Technical Head', place: 'Erode', image: '/coord/TECH_HEAD-BALAMURALI_S_R.jpg', linkedin: 'https://www.linkedin.com/in/baalaa06?utm_source=share_via&utm_content=profile&utm_medium=member_android' },
    { id: 6, name: 'Geethai Priya J', title: 'Technical Head', place: 'Hyderabad', image: '/coord/TECH_HEAD-GEETHAI_PRIYA_J.jpg', linkedin: 'https://www.linkedin.com/in/geetthai-priya060906?utm_source=share_via&utm_content=profile&utm_medium=member_android' },
    { id: 7, name: 'Kamali Sree S', title: 'Technical Head', place: 'Kochi', image: '/coord/TECH_HEAD-KAMALI_SREE.jpeg', linkedin: 'https://www.linkedin.com/in/kamali-sree-97a3b1290?utm_source=share_via&utm_content=profile&utm_medium=member_android' },
    { id: 8, name: 'Kaviselvan S J', title: 'Technical Head', place: 'Madurai', image: '/coord/TECH_HEAD-KAVISELVAN_S_J.jpeg', linkedin: 'https://www.linkedin.com/in/kaviselvan-sj?utm_source=share_via&utm_content=profile&utm_medium=member_android' },
    
    // Joint Technical Heads (2) - Alphabetical order
    { id: 9, name: 'Akiladithya R', title: 'Joint Technical Head', place: 'Mysore', image: '/coord/JOINT_TECH_HEAD2-AKILADITHYA_R.jpeg', linkedin: 'https://www.linkedin.com/in/akiladithya-r-070090293?utm_source=share_via&utm_content=profile&utm_medium=member_android' },
    { id: 10, name: 'Praveenkumar B', title: 'Joint Technical Head', place: 'Pune', image: '/coord/JOINT_TECH_HEAD1-PRAVEENKUMAR_B.jpeg', linkedin: 'https://www.linkedin.com/in/praveenkumar-b-2b31a5287?utm_source=share_via&utm_content=profile&utm_medium=member_android' },
    
    // Non-Technical Heads (2) - Alphabetical order
    { id: 11, name: 'Sanjai R', title: 'Non-Technical Head', place: 'Salem', image: '/coord/NON_TECH_HEAD-SANJAI_R.jpeg', linkedin: 'https://www.linkedin.com/in/sanjai-r-83740628b?utm_source=share_via&utm_content=profile&utm_medium=member_android' },
    { id: 12, name: 'Shivadarshini S', title: 'Non-Technical Head', place: 'Trichy', image: '/coord/NON_TECH_HEAD-SHIVADHARSHINI_S.jpeg', linkedin: 'https://www.linkedin.com/in/shivadarshini07?utm_source=share_via&utm_content=profile&utm_medium=member_android' },
    
    // PR Heads (2) - Alphabetical order
    { id: 13, name: 'Thameamaedhari T', title: 'PR Head', place: 'Vellore', image: '/coord/PR_HEAD_THAMEAMAEDHARI_T.jpeg', linkedin: 'https://www.linkedin.com/in/thameam-dhari-t-1a23b7280?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app' },
    { id: 14, name: 'Vishal Madhav S', title: 'PR Head', place: 'Thanjavur', image: null, linkedin: 'https://www.linkedin.com/in/vishal-madhav-34a22028b/' },
    
    // Design Heads (2) - Alphabetical order
    { id: 15, name: 'Jaiakash P', title: 'Design Head', place: 'Karur', image: '/coord/DESIGN_HEAD-JAIAKASH_P.jpg', linkedin: 'https://www.linkedin.com/in/jai-akash-p-46ab712b2?utm_source=share_via&utm_content=profile&utm_medium=member_android' },
    { id: 16, name: 'Shuchi Anush S', title: 'Design Head', place: 'Tirunelveli', image: '/coord/DESIGN_HEAD1-SHUCHI_ANUSH_S.jpeg', linkedin: 'https://www.linkedin.com/in/shuchi-anush?utm_source=share_via&utm_content=profile&utm_medium=member_android' },
    
    // Treasurers (2) - Alphabetical order
    { id: 17, name: 'Pooja G R', title: 'Treasurer', place: 'Ooty', image: null, linkedin: 'https://www.linkedin.com/in/pooja-rajesh-3585b3290/' },
    { id: 18, name: 'Shareth Raam J S', title: 'Treasurer', place: 'Tuticorin', image: '/coord/TREASURER-SHARETH_RAAM_J_S.jpeg', linkedin: 'https://www.linkedin.com/in/shareth-raam-70199328b?utm_source=share_via&utm_content=profile&utm_medium=member_android' },
    
    // Event Coordinators (4) - Alphabetical order
    { id: 19, name: 'Harish Vardhan D', title: 'Event Coordinator', place: 'Dindigul', image: '/coord/EVENT_COORDINATOR-HARISH_VARDHAN_D.jpeg', linkedin: 'https://www.linkedin.com/in/harishvardhan27?utm_source=share_via&utm_content=profile&utm_medium=member_android' },
    { id: 20, name: 'Janani K', title: 'Event Coordinator', place: 'Kumbakonam', image: '/coord/EVENT_COORDINATOR-JANANI_K.jpeg', linkedin: 'https://www.linkedin.com/in/janani-k-5a6b48328?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app' },
    { id: 21, name: 'Ranganathan K S', title: 'Event Coordinator', place: 'Ramanathapuram', image: '/coord/EVENT_COORDINATOR-RANGANATHAN_K_S.jpeg', linkedin: 'https://www.linkedin.com/in/ranganathan-ks-a1ab56291?utm_source=share_via&utm_content=profile&utm_medium=member_android' },
    { id: 22, name: 'Thirisha P', title: 'Event Coordinator', place: 'Villupuram', image: '/coord/EVENT_COORDINATOR-THIRISHA_P.jpeg', linkedin: 'https://www.linkedin.com/in/thirisha-pandiyan-80a047295?utm_source=share_via&utm_content=profile&utm_medium=member_android' },
  ];

  if (loading) {
    return <div className="coordinators-section">Loading...</div>;
  }

  return (
    <section className="coordinators-section">
      <div className="container">
        <div className="coordinators-section-wrapper">
          <h2 className="section-title">Event Coordinators</h2>
          <p className="section-subtitle">Meet the Team Behind Cryptera 2K26</p>
          
          <div className="coordinators-grid">
            {coordinators.map((coordinator) => (
              <div key={coordinator.id} className="card-wrapper">
                <div className={`tilted-card-container ${coordinator.title.toLowerCase().replace(' ', '-')}`}>
                <TiltedCard
                  imageSrc={coordinator.image || '/images/default-avatar.svg'}
                  altText={coordinator.name}
                  captionText={coordinator.name}
                  containerHeight="250px"
                  containerWidth="250px"
                  imageHeight="250px"
                  imageWidth="250px"
                  rotateAmplitude={12}
                  scaleOnHover={1.2}
                  showMobileWarning={false}
                  showTooltip={true}
                  displayOverlayContent={true}
                  overlayContent={
                    <div className="tilted-card-demo-text">
                      <p className="coordinator-name">{coordinator.name}</p>
                      <p className="coordinator-title">{coordinator.title}</p>
                      {coordinator.linkedin && (
                        <a 
                          href={coordinator.linkedin} 
                          target="_blank" 
                          rel="noopener noreferrer" 
                          className="linkedin-link"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <i className="fab fa-linkedin"></i>
                        </a>
                      )}
                    </div>
                  }
                />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoordinatorsPage;
